import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx';

import { router } from './router';
import { antdTheme } from './styles/theme';
import { useAuthStore } from './features/auth/stores/authStore';
import './styles/global.css';

// Intenta recuperar la sesión usando la cookie httpOnly de refresh
void useAuthStore.getState().bootstrap();

dayjs.locale('es-mx');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('No se encontró el elemento #root');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ConfigProvider locale={esES} theme={antdTheme}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
